export default {
  title: "Tasks",
  description: "Manage your wedding tasks",
  taskList: "Task List",
  addTask: "Add Task",
  editTask: "Edit Task",
  deleteTask: "Delete Task",
  taskTitle: "Task Title",
  taskDescription: "Task Description",
  dueDate: "Due Date",
  priorityLabel: "Priority",
  category: "Category",
  assignedTo: "Assigned To",
  notes: "Notes",
  subtasks: "Subtasks",
  addSubtask: "Add Subtask",
  noTasks: "No tasks found",
  addFirstTask: "Add your first task",
  taskDetails: "Task Details",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  complete: "Complete",
  incomplete: "Incomplete",
  confirmDelete: "Are you sure you want to delete this task?",
  confirmDeleteTask: "Are you sure you want to delete this task?",
  taskAdded: "Task added successfully",
  taskUpdated: "Task updated successfully",
  taskDeleted: "Task deleted successfully",
  taskCreated: "Task successfully created",
  taskCompleted: "Task completed successfully",
  taskUncompleted: "Task marked as incomplete",
  totalTasks: "{{count}} tasks",
  pending: "{{count}} pending",
  completed: "{{count}} completed",
  search: "Search tasks",
  view: {
    list: "List",
    kanban: "Kanban",
    boardView: "Board View",
    calendarView: "Calendar View",
    listView: "List View"
  },
  priority: {
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent"
  },
  status: {
    todo: "To Do",
    pending: "Pending",
    inProgress: "In Progress",
    in_progress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    done: "Done",
    overdue: "Overdue"
  },
  statuses: {
    pending: "Pending",
    in_progress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled"
  },
  categories: {
    planning: "Planning",
    venue: "Venue",
    catering: "Catering",
    flowers: "Flowers",
    photography: "Photography",
    music: "Music",
    attire: "Attire",
    invitations: "Invitations",
    transportation: "Transportation",
    decoration: "Decoration",
    legal: "Legal",
    beauty: "Beauty",
    other: "Other",
    ceremony: "Ceremony",
    reception: "Reception",
    vendors: "Vendors",
    guests: "Guests",
    honeymoon: "Honeymoon"
  },
  filters: {
    title: "Filters",
    all: "All Tasks",
    pending: "Pending",
    completed: "Completed",
    overdue: "Overdue",
    today: "Due Today",
    thisWeek: "Due This Week",
    thisMonth: "Due This Month",
    status: "Status",
    category: "Category",
    dueDate: "Due Date",
    priority: "Priority",
    priorityLabel: "Priority",
    search: "Search for a task",
    sortBy: "Sort by",
    clear: "Clear filters",
    reset: "Reset",
    options: {
      title: "Title",
      dueDate: "Due date",
      priority: "Priority",
      status: "Status"
    },
    assignee: "Assigned to",
    apply: "Apply",
    previous: "Previous",
    next: "Next"
  },
  sort: {
    dueDate: "Due Date",
    priorityLabel: "Priority",
    status: "Status",
    title: "Title",
    created: "Created Date"
  },
  dueDateWarning: "Due date is approaching",
  overdue: "Overdue",
  dueToday: "Due Today",
  dueTomorrow: "Due Tomorrow",
  dueThisWeek: "Due This Week",
  dueNextWeek: "Due Next Week",
  dueThisMonth: "Due This Month",
  dueNextMonth: "Due Next Month",
  noDueDate: "No Due Date",
  progress: "Progress",
  completionRate: "Completion Rate",
  completedTasks: "Completed Tasks",
  pendingTasks: "Pending Tasks",
  overdueTasks: "Overdue Tasks",
  taskProgress: "Task Progress",
  milestones: "Milestones",
  createMilestone: "Create Milestone",
  milestoneTitle: "Milestone Title",
  milestoneDate: "Milestone Date",
  milestoneDescription: "Milestone Description",
  milestoneAdded: "Milestone added successfully",
  milestoneUpdated: "Milestone updated successfully",
  milestoneDeleted: "Milestone deleted successfully",
  timeline: "Timeline",
  ganttChart: "Gantt Chart",
  searchPlaceholder: "Search by title or description",
  noResults: "No tasks match your search",
  clearSearch: "Clear Search",
  export: "Export",
  import: "Import",
  exportTasks: "Export Tasks",
  importTasks: "Import Tasks",
  template: "Template",
  useTemplate: "Use Template",
  weddingPlanningTemplate: "Wedding Planning Template",
  customTemplate: "Custom Template",
  templateApplied: "Template applied successfully",
  bulkActions: "Bulk Actions",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  markCompleted: "Mark Completed",
  markPending: "Mark Pending",
  changeCategory: "Change Category",
  changePriority: "Change Priority",
  bulkDelete: "Bulk Delete",
  selectedTasks: "{{count}} tasks selected",
  bulkUpdateSuccess: "{{count}} tasks updated successfully",
  bulkDeleteSuccess: "{{count}} tasks deleted successfully",
  confirmBulkDelete: "Are you sure you want to delete {{count}} tasks?",
  dependencies: "Dependencies",
  addDependency: "Add Dependency",
  dependsOn: "Depends On",
  blockedBy: "Blocked By",
  blocks: "Blocks",
  noDependencies: "No dependencies",
  attachments: "Attachments",
  addAttachment: "Add Attachment",
  uploadFile: "Upload File",
  downloadFile: "Download File",
  deleteFile: "Delete File",
  fileUploaded: "File uploaded successfully",
  fileDeleted: "File deleted successfully",
  comments: "Comments",
  addComment: "Add Comment",
  commentPlaceholder: "Add a comment...",
  commentAdded: "Comment added successfully",
  commentUpdated: "Comment updated successfully",
  commentDeleted: "Comment deleted successfully",
  noComments: "No comments yet",
  notifications: "Notifications",
  reminders: "Reminders",
  setReminder: "Set Reminder",
  reminderTime: "Reminder Time",
  reminderSet: "Reminder set successfully",
  reminderDeleted: "Reminder deleted successfully",
  emailNotifications: "Email Notifications",
  pushNotifications: "Push Notifications",
  recurring: "Recurring",
  recurringTask: "Recurring Task",
  recurrencePattern: "Recurrence Pattern",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  yearly: "Yearly",
  custom: "Custom",
  endDate: "End Date",
  occurrences: "Occurrences",
  recurringTaskCreated: "Recurring task created successfully",
  analytics: "Analytics",
  productivity: "Productivity",
  timeTracking: "Time Tracking",
  startTimer: "Start Timer",
  stopTimer: "Stop Timer",
  timeSpent: "Time Spent",
  estimatedTime: "Estimated Time",
  actualTime: "Actual Time",
  efficiency: "Efficiency",
  taskVelocity: "Task Velocity",
  burndownChart: "Burndown Chart",
  velocityChart: "Velocity Chart",
  form: {
    title: "Task title",
    description: "Task description",
    category: "Category",
    priority: "Priority",
    status: "Status",
    dueDate: "Due date",
    new: "New task",
    edit: "Edit task",
    titlePlaceholder: "Task title",
    descriptionPlaceholder: "Task description",
    dueDatePlaceholder: "Due date",
    categoryPlaceholder: "Category",
    priorityPlaceholder: "Priority",
    statusPlaceholder: "Status",
    assignedTo: "Assigned to",
    assignedToPlaceholder: "Assignee",
    notes: "Notes",
    notesPlaceholder: "Additional notes",
    errors: {
      titleRequired: "Title is required",
      descriptionRequired: "Description is required",
      submitFailed: "Error saving task",
      titleMinLength: "Title must contain at least 3 characters",
      statusRequired: "Status is required",
      priorityRequired: "Priority is required",
      categoryRequired: "Category is required",
      dueDateRequired: "Due date is required"
    },
    submit: "Save",
    cancel: "Cancel",
    name: "Last name",
    assignee: "Assigned to",
    confirmCancel: "Are you sure you want to cancel? Unsaved changes will be lost."
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
    complete: "Complete",
    moveTask: "Move task"
  },
  errors: {
    moveTask: "Error moving task",
    loadFailed: "Failed to load tasks",
    addFailed: "Failed to add task",
    updateFailed: "Failed to update task",
    deleteFailed: "Failed to delete task",
    submit: "Error submitting task"
  },
  sharing: {
    title: "Share task list",
    share: "Share",
    success: "Task list shared successfully",
    readOnly: "Read only",
    edit: "Edit",
    defaultMessage: "I shared a task with you",
    recipientEmail: "Recipient's email",
    emailPlaceholder: "Enter recipient email",
    recipientName: "Recipient name",
    namePlaceholder: "Enter recipient name",
    message: "Message",
    messagePlaceholder: "Enter your message",
    accessLevel: "Access level"
  },
  tasks: {
    dueDate: "Due Date"
  },
  messages: {
    createSuccess: "Task added successfully",
    updateSuccess: "Task updated successfully",
    deleteSuccess: "Task deleted successfully",
    deleteConfirm: "Are you sure you want to delete this task?",
    error: "An error occurred"
  },
  modal: {
    title: "Task",
    edit: "Edit task",
    delete: "Delete task",
    confirmDelete: "Are you sure you want to delete this task?"
  },
  demoTasks: {
    bookVenue: {
      title: "Book the venue",
      description: "Find and book the ideal venue for the ceremony and reception"
    },
    orderInvitations: {
      title: "Order invitations",
      description: "Choose and order invitations for guests"
    },
    bookCaterer: {
      title: "Book the caterer",
      description: "Select and book the caterer for the wedding meal"
    },
    chooseDress: {
      title: "Choose the dress",
      description: "Find the perfect wedding dress"
    },
    bookPhotographer: {
      title: "Book the photographer",
      description: "Select and book the photographer to capture your day"
    },
    chooseRings: {
      title: "Choose the rings",
      description: "Find the perfect wedding rings for your couple"
    }
  }
};
